// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Pagination.module.scss  */
.Pagination-module-Root_2gW {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  margin: var(--pagination-container-margin); }

.Pagination-module-Dots_KAs {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: var(--pagination-item-inline-margin);
  font-size: 1em;
  line-height: 1em;
  color: var(--pagination-text-inactive-color); }

.Pagination-module-ArrowBtn_q09 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  color: var(--pagination-arrow-color-inactive-color);
  border: var(--pagination-arrow-border);
  background-color: var(--pagination-arrow-background-inactive-color); }
  .Pagination-module-ArrowBtn_q09:hover {
    cursor: pointer;
    color: var(--pagination-arrow-color-hover-color);
    background-color: var(--pagination-arrow-background-hover-color); }
  .Pagination-module-ArrowBtn_q09:first-child {
    margin-left: var(--pagination-item-inline-margin); }
  .Pagination-module-ArrowBtn_q09:last-child {
    margin-right: var(--pagination-item-inline-margin); }

.Pagination-module-NumbersContainer_3Hd {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-right: var(--pagination-item-inline-margin);
  font-size: 1em;
  line-height: 1em; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Pagination/Pagination.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0CAA0C,EAAE;;AAE9C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;EACjD,cAAc;EACd,gBAAgB;EAChB,4CAA4C,EAAE;;AAEhD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,mDAAmD;EACnD,sCAAsC;EACtC,mEAAmE,EAAE;EACrE;IACE,eAAe;IACf,gDAAgD;IAChD,gEAAgE,EAAE;EACpE;IACE,iDAAiD,EAAE;EACrD;IACE,kDAAkD,EAAE;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,cAAc;EACd,gBAAgB,EAAE","sourcesContent":["/*  imported from Pagination.module.scss  */\n.Pagination-module-Root_2gW {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: auto;\n  margin: var(--pagination-container-margin); }\n\n.Pagination-module-Dots_KAs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: var(--pagination-item-inline-margin);\n  font-size: 1em;\n  line-height: 1em;\n  color: var(--pagination-text-inactive-color); }\n\n.Pagination-module-ArrowBtn_q09 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  color: var(--pagination-arrow-color-inactive-color);\n  border: var(--pagination-arrow-border);\n  background-color: var(--pagination-arrow-background-inactive-color); }\n  .Pagination-module-ArrowBtn_q09:hover {\n    cursor: pointer;\n    color: var(--pagination-arrow-color-hover-color);\n    background-color: var(--pagination-arrow-background-hover-color); }\n  .Pagination-module-ArrowBtn_q09:first-child {\n    margin-left: var(--pagination-item-inline-margin); }\n  .Pagination-module-ArrowBtn_q09:last-child {\n    margin-right: var(--pagination-item-inline-margin); }\n\n.Pagination-module-NumbersContainer_3Hd {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding-right: var(--pagination-item-inline-margin);\n  font-size: 1em;\n  line-height: 1em; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
